import React from "react";

interface ContainerCardProps {
  heading?: string;
  children: any;
}

function ContainerCard({ children, heading }: ContainerCardProps) {
  return (
    <div className="card mb-3">
      {heading ? <div className="card-header">{heading}</div> : null}
      <div className="card-body">{children}</div>
    </div>
  );
}

export default ContainerCard;
